import React from 'react'
import { HeroContainer, HeroLeftContainer, Img, HeroRightContainer, HeroInnerContainer, TextLoop, Title, Span, SubTitle,SocialMediaIcons,SocialMediaIcon } from './HeroStyle'
import HeroImg from '../../images/HeroImage.JPG'
import Typewriter from 'typewriter-effect';
import { Bio } from '../../data/constants';
import DescriptionIcon from '@mui/icons-material/Description';
import MailIcon from '@mui/icons-material/Mail';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GithubIcon from '@mui/icons-material/GitHub';

const HeroSection = () => {
    return (
        <div id="about">
            <HeroContainer>
                <HeroInnerContainer >
                    <HeroLeftContainer id="Left">
                        <Title>Hi, I am {Bio.name}</Title>
                        <TextLoop>
                            <Span>
                                <Typewriter
                                    options={{
                                        strings: Bio.roles,
                                        autoStart: true,
                                        loop: true,
                                    }}
                                />
                            </Span>
                        </TextLoop>
                        <SubTitle>{Bio.description}</SubTitle>
                        <SubTitle>{Bio.description1}</SubTitle>
                        <SubTitle>{Bio.description2}</SubTitle>
                        <SubTitle>{Bio.description3}</SubTitle>
                        <SocialMediaIcons>
                            <SocialMediaIcon href={Bio.github} target="display">
                                <GithubIcon style={{ fontSize: "4rem" }} />
                            </SocialMediaIcon>
                            <SocialMediaIcon href={Bio.linkedin} target="display">
                                <LinkedInIcon style={{ fontSize: "4rem" }} />
                            </SocialMediaIcon>
                            <SocialMediaIcon href={Bio.email} target="display">
                                <MailIcon style={{ fontSize: "4rem" }} />
                            </SocialMediaIcon>
                            <SocialMediaIcon href={Bio.resume} target="display">
                                <DescriptionIcon style={{ fontSize: "4rem" }} />
                            </SocialMediaIcon>
                        </SocialMediaIcons>
                    </HeroLeftContainer>

                    <HeroRightContainer id="Right">

                        <Img src={HeroImg} alt="hero-image"/>
                    </HeroRightContainer>
                </HeroInnerContainer>
                <p></p>

            </HeroContainer>
        </div>
    )
}

export default HeroSection